import {
  Box,
  Card,
  IconCheckmarkCircle,
  IconCrossCircle,
  IconInfoCircle,
  Text,
} from '@tocktix/pantry';
import { FunctionComponent } from 'react';

export type UserHistoryEventCardProps = {
  title: string;
  icon: 'success' | 'danger' | 'info';
  dateTime: string;
  reason?: string;
  updatedByTockPatronId?: bigint;
};

const UserHistoryEventCard: FunctionComponent<UserHistoryEventCardProps> = ({
  title,
  icon,
  dateTime,
  reason,
  updatedByTockPatronId,
}) => (
  <Card>
    <Card.Body>
      <Box display="flex" flexDirection="column" gap={100}>
        <Box display="flex" alignItems="center" gap={100}>
          {icon === 'success' && <IconCheckmarkCircle size={200} color="fgSuccessBase" />}
          {icon === 'danger' && <IconCrossCircle size={200} color="fgDangerBase" />}
          {icon === 'info' && <IconInfoCircle size={200} color="fgSubtle" />}
          <Text variant="bodyStrong">{title}</Text>
        </Box>
        <Text variant="bodySm" color="fgSubtle">
          {dateTime}
        </Text>
        {reason ? (
          <Text variant="bodySm">
            <Text variant="bodySmStrong" as="span">
              Reason:{' '}
            </Text>
            {reason}
          </Text>
        ) : null}
        {updatedByTockPatronId != null ? (
          <Text variant="bodySm">
            <Text variant="bodySmStrong" as="span">
              Updated by Tock Patron ID:{' '}
            </Text>
            {updatedByTockPatronId.toString()}
          </Text>
        ) : null}
      </Box>
    </Card.Body>
  </Card>
);

export default UserHistoryEventCard;
